import { render, staticRenderFns } from "./SourceLabel.vue?vue&type=template&id=138e3207&"
import script from "./SourceLabel.vue?vue&type=script&lang=js&"
export * from "./SourceLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports